export const CARE_SCOPES = ['timeline', 'vitals', 'reports', 'updates', 'medications'];
export const entryScope = (type) =>
  ({
    vital: 'vitals',
    report: 'reports',
    prescription: 'medications',
    pharmacy: 'medications',
    event: 'timeline'
  })[type] || 'updates';
export const activeMember = (member) =>
  member.status === 'accepted' &&
  (!member.expiresAt || new Date(member.expiresAt).getTime() > Date.now());
export const formatCareDate = (value, withTime = true) => {
  if (!value || !Number.isFinite(new Date(value).getTime())) return 'Date unavailable';
  return new Date(value).toLocaleString(undefined, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    ...(withTime ? { hour: '2-digit', minute: '2-digit' } : {})
  });
};
export const localDateTime = (date = new Date()) => {
  const pad = (n) => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
};
export const entryStatus = (entry) =>
  entry.legacy
    ? 'Existing record'
    : {
        'not-sent': 'Not sent for review',
        pending: 'Awaiting review',
        reviewed: 'Reviewed',
        'needs-information': 'More information requested'
      }[entry.status] || 'Recorded';
export const metricInfo = {
  blood_pressure: { label: 'Blood pressure', unit: 'mmHg' },
  glucose: { label: 'Blood glucose', unit: 'mg/dL' },
  weight: { label: 'Weight', unit: 'kg' },
  pulse: { label: 'Pulse', unit: 'bpm' },
  temperature: { label: 'Temperature', unit: '°C' },
  spo2: { label: 'Oxygen saturation', unit: '%' }
};
export const measurementText = (measurement) =>
  measurement
    ? `${measurement.value}${measurement.metric === 'blood_pressure' ? `/${measurement.secondaryValue}` : ''} ${measurement.unit}`
    : '';

export function validateCareEntry(draft) {
  const occurred = new Date(draft.occurredAt).getTime();
  if (!Number.isFinite(occurred) || occurred > Date.now())
    return 'Choose a valid time at or before now.';
  if (draft.type === 'vital') {
    if (!metricInfo[draft.metric]) return 'Choose a measurement type.';
    if (!Number.isFinite(Number(draft.value)) || Number(draft.value) <= 0)
      return 'Enter a positive measurement.';
    if (
      draft.metric === 'blood_pressure' &&
      (!Number.isFinite(Number(draft.secondaryValue)) ||
        Number(draft.secondaryValue) <= 0 ||
        Number(draft.value) <= Number(draft.secondaryValue))
    )
      return 'Enter both blood pressure values, with systolic greater than diastolic.';
    if (draft.metric === 'spo2' && Number(draft.value) > 100)
      return 'Oxygen saturation cannot exceed 100%.';
    if (draft.metric === 'glucose' && !['fasting', 'after-meal', 'random'].includes(draft.context))
      return 'Choose the context for this glucose reading.';
  } else if (!draft.title.trim() || !draft.body.trim())
    return 'Add a title and details for your update.';
  if (draft.title.length > 160 || draft.body.length > 4000)
    return 'Use at most 160 characters for the title and 4,000 for the details.';
  return null;
}

export function careEntryPayload(draft) {
  const vital = draft.type === 'vital';
  return {
    type: draft.type,
    title: vital ? metricInfo[draft.metric].label : draft.title.trim(),
    body: draft.body.trim(),
    occurredAt: new Date(draft.occurredAt).toISOString(),
    reviewerId: draft.reviewerId || null,
    ...(vital
      ? {
          measurement: {
            metric: draft.metric,
            value: Number(draft.value),
            unit: metricInfo[draft.metric].unit,
            ...(draft.metric === 'blood_pressure'
              ? { secondaryValue: Number(draft.secondaryValue) }
              : {}),
            context: draft.metric === 'glucose' ? draft.context : draft.readingContext.trim()
          }
        }
      : {})
  };
}
